import { uuid } from './regex';

export const SettingsRoutes = {
    path: 'settings',
    account: {
        path: 'account',
        basic: {
            path: 'basic',
        },
        mfa: {
            path: 'mfa',
            create: {
                path: 'create',
            },
            forcingActivation: {
                path: 'forcingActivation',
            },
        },
        password: {
            path: 'password',
            recovery: {
                path: 'recovery',
            },
        },
    },
    sessions: {
        path: 'sessions',
    },
    workspaceData: {
        path: 'workspaceData',
    },
    points: {
        path: 'points',
        details: {
            path: ':id(\\d+)',
            result: {
                path: 'result',
            },
        },
        purchase: {
            path: 'purchase',
        },
        statements: {
            path: 'statements',
        },
    },
    subscriptions: {
        path: 'subscriptions',
        details: {
            path: ':id(\\d+)',
            result: {
                path: 'result',
            },
        },
        explain: {
            path: 'explain',
        },
        new: {
            path: 'new',
        },
        statements: {
            path: 'statements',
        },
        purchase: {
            path: 'purchase',
            specificPlan: {
                path: ':id(\\d+)',
            },
            planType: {
                path: ':planType(prime|black)',
            },
        },
        freeTrial: {
            path: 'freeTrial',
        },
        paymentMethod: {
            path: 'paymentMethod',
        },
    },
    notifications: {
        path: 'notifications',
    },
    rental: {
        path: 'rental',
    },
    users: {
        path: 'users',
        changeOwner: {
            path: 'changeOwner',
        },
        invite: {
            path: 'invite',
            edit: {
                path: `edit/:inviteId(${uuid})`,
            },
        },
        edit: {
            path: 'edit/:userId(\\d+)',
        },
    },
};
